import BasicImage from 'core/BasicImage';
import { Product } from 'shared/sections/TechnicalExpertise/ExpertisePanel';

import cn from './style.module.sass';

type BadgeListProps = {
    products: Product[];
};

export default function BadgeList({ products }: BadgeListProps) {
    return (
        <div className={cn['badgeList']}>
            {products.map(product => (
                <div key={product.name} className={cn['badgeList__item']}>
                    {product.logo && (
                        <BasicImage
                            width={32}
                            height={32}
                            src={product.logo}
                            alt="logo"
                            className={cn['badgeList__logo']}
                        />
                    )}
                    <div className={cn['badgeList__name']}>{product.name}</div>
                </div>
            ))}
        </div>
    );
}
